import React, { useEffect, useState } from "react";

const Userinfo = () => {
  const [users, setUsers] = useState([]);

  useEffect(() => {
    const loadUsers = async () => {
      try {
        const result = await fetch(`${process.env.REACT_APP_API_URL}/api/auth/usersinfo`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });

        const data = await result.json();

        if (result.ok) {
          setUsers(data.users);
        } else {
          console.error("Error:", data.message);
        }
      } catch (err) {
        console.error("Fetch failed:", err);
      }
    };

    loadUsers();
  }, []);

  // INLINE STYLES
  const styles = {
    container: {
      maxWidth: "900px",
      margin: "40px auto",
      padding: "20px",
      background: "#fff",
      borderRadius: "10px",
      boxShadow: "0 0 10px rgba(0,0,0,0.1)",
      fontFamily: "Arial, sans-serif",
    },
    title: {
      textAlign: "center",
      fontSize: "28px",
      marginBottom: "25px",
      fontWeight: "bold",
      color: "#2c3e50",
    },
    tableWrapper: {
      overflowX: "auto",
      borderRadius: "10px",
      border: "1px solid #ddd",
    },
    table: {
      width: "100%",
      borderCollapse: "collapse",
    },
    th: {
      background: "#34495e",
      color: "white",
      padding: "12px",
      textAlign: "left",
      fontSize: "16px",
    },
    td: {
      padding: "12px",
      borderBottom: "1px solid #ddd",
      fontSize: "15px",
    },
    rowEven: {
      background: "#f7f7f7",
    },
    rowHover: {
      cursor: "pointer",
    },
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>User Information</h2>

      <div style={styles.tableWrapper}>
        <table style={styles.table}>
          <thead>
            <tr>
              <th style={styles.th}>ID</th>
              <th style={styles.th}>Name</th>
              <th style={styles.th}>Email</th>
              <th style={styles.th}>Role</th>
            </tr>
          </thead>

          <tbody>
            {users.map((user, index) => (
              <tr
                key={user.id}
                style={{
                  ...styles.rowHover,
                  ...(index % 2 === 0 ? styles.rowEven : {}),
                }}
              >
                <td style={styles.td}>{user.id}</td>
                <td style={styles.td}>{user.name}</td>
                <td style={styles.td}>{user.email}</td>
                <td style={styles.td}>{user.role}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Userinfo;
